import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { Button, Spinner } from "react-bootstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { apiCall } from "utils/httpClient";
import apiEndPoint from "utils/apiEndPoint";
import { truncateText } from "utils/utils";
import { isEmpty } from "utils/utils";
import { FaBars, FaTimes } from "react-icons/fa";
import HomeCategoryModal from "pages/home/homecategorymodal";

function TabSlider({ setSelectCategoryId, searchCategory, handleAllTemplateData, languageData, setCurrentPage, selectCategoryId }) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isMegaMenuOpen, setIsMegaMenuOpen] = useState(false);
  const [searchTemplate, setSearchTemplate] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  const getDynamicSlidesToShow = (categories) => {
    if (categories.length === 0) return 1;

    const avgLength =
      categories.reduce((total, cat) => total + (cat.category_name?.length || 0), 0) / categories.length;

    if (avgLength <= 6) return 6;
    if (avgLength <= 10) return 5;
    if (avgLength <= 14) return 4;
    if (avgLength <= 20) return 3;

    return 2;
  };
  const megaMenuRef = useRef(null);
  const toggleButtonRef = useRef(null);

  const settings = {
    dots: false,
    infinite: categories.length > 1,
    speed: 1500,
    variableWidth: true,  // <-- allow dynamic width
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    centerMode: false,
  };
  const chunkArray = (arr, chunks) => {
    const perChunk = Math.ceil(arr.length / chunks);
    return Array.from({ length: chunks }, (v, i) =>
      arr.slice(i * perChunk, i * perChunk + perChunk)
    );
  };


  const getCategoryList = async () => {
    let params = {};
    // setLoading(true);
    if (!isEmpty(searchCategory)) {
      params["category_name"] = searchCategory;
    }
    const { data } = await apiCall("post", apiEndPoint.GETCATEGORY, params);
    if (data.status === 200) {
      setCategories(data.data);
    } else {
      setCategories([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    getCategoryList();
  }, [searchCategory]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        megaMenuRef.current &&
        !megaMenuRef.current.contains(event.target) &&
        toggleButtonRef.current &&
        !toggleButtonRef.current.contains(event.target)
      ) {
        setIsMegaMenuOpen(false);
      }
    }

    if (isMegaMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMegaMenuOpen]);


  return (
    <>
      <div className="tab-slider-container" style={{ width: "100%", position: 'relative' }}>
        <Button
          variant="primary"
          ref={toggleButtonRef}
          onClick={() => {
            setIsMegaMenuOpen(prev => !prev);
            handleAllTemplateData();
          }}
          style={{
            width: "30px",
            height: "30px",
            padding: 0,              // remove default padding for accurate sizing
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {isMegaMenuOpen ? (
            <FaTimes style={{ fontSize: "15px" }} />
          ) : (
            <FaBars style={{ fontSize: "15px" }} />
          )}
        </Button>


        {isMegaMenuOpen && (
          <div className="mega-menu-box" ref={megaMenuRef}>
            <HomeCategoryModal setSelectCategoryId={setSelectCategoryId}
              // searchCategory={searchCategory}
              setCurrentPage={setCurrentPage}
              handleAllTemplateData={handleAllTemplateData}
              languageData={languageData} setIsMegaMenuOpen={setIsMegaMenuOpen} setSearchTemplate={setSearchTemplate} />

            {/* <div className="mega-menu-box" ref={megaMenuRef}>
            <div className="mega-menu-columns">
              {chunkArray(categories, 8).map((column, columnIndex) => (
                <ul key={columnIndex} className="mega-menu-column">
                  {column.map((item, i) => (
                    <li
                      key={i}
                      className="mega-menu-item"
                      onClick={() => {
                        setSelectCategoryId(item?._id);
                        setCurrentPage(0);
                        setIsMegaMenuOpen(false);
                      }}
                    >
                      {item?.category_name}
                    </li>
                  ))}
                </ul>
              ))}
            </div>
          </div> */}
          </div>
        )}

        <span>
          <Button variant="outline" style={{
            width: "30px",
            height: "30px",
            padding: 0,              // remove default padding for accurate sizing
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
            |
          </Button>
        </span>
        {loading ? (
          <div style={{ textAlign: "center", marginLeft: "10px" }}>
            <Spinner animation="border" variant="primary" size="sm" />
          </div>
        ) : (
          categories.length > 0 && (
            <>
              <Slider {...settings} style={{ marginLeft: "30px" }}>
                {categories.map((item, i) => (
                  <p
                    key={i}
                    className={`category-slickbtn ${selectedCategoryId === item?._id ? 'active' : ''}`}
                    onClick={() => {
                      setSelectCategoryId(item?._id);
                      setSelectedCategoryId(item?._id);
                      setCurrentPage(0);
                    }}
                  >
                    {item?.category_name}
                  </p>
                ))}
              </Slider>
            </>
          )
        )}
        {
          selectCategoryId && (
            <Button
              variant="link"
              onClick={() => {
                handleAllTemplateData();
                setIsMegaMenuOpen(false);
                setSelectedCategoryId(null);
              }} className="clrbtn-templateslider" >
              <FaTimes /> {languageData?.clear}
            </Button>
          )
        }
      </div>

    </>
  );
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        ...style,
        display: "block",
        right: "-30px",
        top: "45%",
        transform: "translateY(-50%)",
        zIndex: 2,
        cursor: "pointer",
      }}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        ...style,
        display: "block",
        left: "-30px",
        top: "45%",
        transform: "translateY(-50%)",
        zIndex: 2,
        cursor: "pointer",
      }}
    />
  );
}

export default TabSlider;
